export const ALL_PRODUCTS_SCOPE_URI = 'all'
export const PRODUCT_SEGMENT_URI = 'detail'
export const PACKAGES_SEGMENT_URI = 'packages'
export const SALEHOME_SEGMENT_URI = 'saleHome'
export const SELECTION_SEGMENT_URI = 'selection'

export const ALL_PRODUCTS_TYPE = 'all-products'

export const HEADER_HEIGHT = 120
export const STATIC_HEADER_HEIGHT = 70
export const CATALOG_BRANDLOGO_MARGIN = 32

export const UNIVERSES_PAGE_NAME = 'Universes page'
export const CATALOG_PAGE_NAME = 'Catalogue page'
export const PRODUCT_PAGE_NAME = 'Product page'

export const ALL_PRODUCTS_TRACKING_NAME = 'alloffers'
